import { ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';

import { storeSubscriptionAPIInjector } from 'src/app/api/infra/store-api-service.injector';
import { BillingApiService } from 'src/app/api/services/billing-api.service';
import { StoreSubscriptionAPI } from 'src/app/api/store-api';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { CurrentPlanService } from 'src/app/components/plans/current-plan.service';
import {
  ScrollingListFactoryService,
  ScrollingListInstance,
} from 'src/app/components/scrolling-list/services/scrolling-list-factory.service';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';
import { BillingUtilsService } from '../../services/billing-utils.service';
import { InvoiceService } from '../../services/invoice.service';

@Component({
  selector: 'billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  standalone: false,
})
export class BillingComponent implements OnDestroy {
  private subscription;
  protected subscriptionsDisplayedColumns = [
    'subscription',
    'status',
    'renewalDate',
    'planAmount',
    'shipTo',
  ];
  protected invoicesDisplayedColumns = [
    'status',
    'date',
    'description',
    'amount',
    'invoice',
    'actions',
    'shipTo',
  ];
  public company = this.companyStateService.getCopyOfSelectedCompany();

  public subscriptions: ScrollingListInstance =
    this.scrollingListFactory.create(
      this.storeSubscriptionApiService.getSubscriptions.bind(
        this.storeSubscriptionApiService,
      ),
      {
        name: 'Subscriptions',
        onListUpdate: () => {
          this.changeDetectorRef.detectChanges();
        },
      },
    );
  public invoices: ScrollingListInstance = this.scrollingListFactory.create(
    this.billingApiService.getInvoices.bind(this.billingApiService),
    {
      name: 'Invoices',
      onListUpdate: () => {
        this.changeDetectorRef.detectChanges();
      },
    },
  );

  constructor(
    private broadcaster: BroadcasterService,
    private changeDetectorRef: ChangeDetectorRef,
    private companyStateService: CompanyStateService,
    private scrollingListFactory: ScrollingListFactoryService,
    public currentPlanService: CurrentPlanService,
    @Inject(storeSubscriptionAPIInjector)
    private storeSubscriptionApiService: StoreSubscriptionAPI,
    private billingApiService: BillingApiService,
    protected billingUtils: BillingUtilsService,
    public invoiceService: InvoiceService,
  ) {
    this.invoiceService.generateToken();

    this.subscription = this.broadcaster.on(
      'risevision.company.planStarted',
      () => {
        this.subscriptions.doSearch();
      },
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  showSubscriptionLink(subscription) {
    if (subscription.customer_id !== this.company.id) {
      return false;
    } else if (this.billingUtils.isCancelled(subscription)) {
      return false;
    } else if (this.billingUtils.isPaused(subscription)) {
      return false;
    } else if (this.billingUtils.isTrial(subscription)) {
      return false;
    }

    return true;
  }
}
